<template>
  <div class="section" id="home">
    <div class="left">
      <div class="left_wrap">
        <div class="title">
          <div class="one">{{ data.text_1 }}</div>
          <div class="two">{{ data.text_2 }}</div>
        </div>
        <div class="sub_title">
          {{ data.text_3 }}
        </div>
        <div class="options">
          <button>{{ data.text_4 }}</button>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="cover"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      text_1: "Learning",
      text_2: "Solutions",
      text_3: `100% live and online, and uses interactive technology to teach people
          the tech skills they need to launch a new career in just 9 months.`,
      text_4: "Sign up",
    },
  },
};
</script>
<style>
.section#home {
  display: flex;
  padding: 1rem 2.5rem;
  height: calc(100vh - 75px);
}
.section#home .left {
  display: flex;
  justify-content: center;
  width: 100%;
}
.section#home .left .left_wrap {
  padding: 0rem 12rem 0rem 5rem;
  padding-top: 30%;
}
.section#home .left .title {
  font-size: 5rem;
  font-family: "Volkhov", serif;
  font-weight: 700;
  line-height: 5.5rem;
}
.section#home .left .title .two {
  color: #ea3c49;
}
.section#home .left .sub_title {
  margin-top: 1.8rem;
  margin-bottom: 2.2rem;
  font-size: 1.1rem;
}
.section#home .left button {
  padding: 8px 30px;
  border-radius: 5px;
  background-color: #4571c9;
  color: #fff;
  border: none;
  width: 70%;
  box-shadow: none;
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 500;
  transition: background-color 0.2s;
}
.section#home .left button:hover {
  background-color: #3a66bd;
  transition: background-color 0.2s;
}
.section#home .right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.section#home .right .cover {
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  background-image: url("./cover_1.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 30px;
  height: 600px;
}
</style>